"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertSizeToNumber = void 0;
var convertSizeToNumber = function (size) {
    if (typeof size === 'number')
        return size;
    // Check if the string is a viewport width, if so convert it to pixels
    if (size.includes('vh') || size.includes('vw')) {
        return window.innerWidth * (parseInt(size.replace(/vh|vw|\s/g, ''), 10) / 100);
    }
    if (size.includes('%')) {
        // Check if the string is a percentage, if so convert it to pixels
        return (parseInt(size.replace(/%|\s/g, ''), 10) / 100) * window.innerWidth;
    }
    return parseInt(size, 10);
};
exports.convertSizeToNumber = convertSizeToNumber;
